import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { OnboardingViewComponent } from './views/onboarding/onboarding.view';
import { MODULE_CONFIG, ModuleConfig } from './config/modules.config';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, TopNavComponent, SidebarComponent, FooterComponent, OnboardingViewComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private auth = inject(AuthService);

  activeModule = 'portfolio';
  authState: 'connecting' | 'ready' | 'error' = 'connecting';

  get moduleConfig(): ModuleConfig {
    return MODULE_CONFIG[this.activeModule];
  }

  onModuleSwitch(id: string): void {
    this.activeModule = id;
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.auth.ensureAuth();
      this.authState = 'ready';
    } catch {
      this.authState = 'error';
    }
  }
}
